'use client';

import { Switch } from 'src/general/components/forms/Input/atoms/OptionFieldInput';
import { ControlInputGroup } from 'src/general/components/forms/Input/ControlInput/ControlInputGroup';
import { Icon } from 'src/general/Icons/Icon';
import { FilterValues } from 'src/types/CataloguePage.types';
import { FilterOption } from '../../PlpFilters.type';

type Props = {
  onChange: (filter: FilterOption) => void;
  value: string;
};

export const AvailableFilterInput = ({ onChange, value }: Props) => {
  return (
    <div className="AvailableFilter-wrapper">
      <Icon name="show" />
      <ControlInputGroup
        id="state"
        name="state"
        type="switch"
        variant="isolated"
        inputIcon={Switch}
        options={[{ label: 'Show available only', value: 'available' }]}
        inputPlacement="end"
        className="AvailableFilter-switch"
        value={value}
        onChange={(e) =>
          onChange({ filter: FilterValues.State, value: e, slug: e, label: 'Show available only' } as FilterOption)
        }
      />
    </div>
  );
};
